import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IconService } from './icon.service';
import { FaIconComponent, IconDefinition } from '@fortawesome/angular-fontawesome';
@Component({
  selector: 'ui-icon',
  standalone: true,
  imports: [CommonModule, FaIconComponent],
  template: `
    <fa-icon
      [icon]="getIcon(name)"
      [class]="getIconClasses()"
    >
    </fa-icon>
  `
})
export class IconComponent {
  @Input() name!: string;
  @Input() size: 'sm' | 'base' | 'lg' = 'base';
  @Input() color?: 'primary' | 'secondary' | 'danger' | 'success' | 'warning';

  constructor(private iconService: IconService) {}

  getIconClasses(): string {
    const sizeClasses = {
      sm: 'text-icon-sm',
      base: 'text-icon-base',
      lg: 'text-icon-lg'
    }[this.size];

    const colorClasses = this.color ? {
      primary: 'text-primary-600',
      secondary: 'text-slate-600',
      danger: 'text-danger-600',
      success: 'text-green-600',
      warning: 'text-yellow-600'
    }[this.color] : '';

    return `${sizeClasses} ${colorClasses}`;
  }

  getIcon(name: string): IconDefinition {
    return this.iconService.getIcon(name);
  }
}
